import { Component } from '@angular/core';

@Component({
  selector: 'rcp-label-container',
  template: `<ng-content />`,
  styles: `
    :host {
      display: flex;
      flex-wrap: wrap;
      gap: var(--list-item-spacing);
    }
  `,
})
export class LabelContainerComponent {}
